import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const districtURL = `api/v1/location-app/district`;

//obtaining the paginated data
export const getDistrict = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${districtURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};
//obtaining all fiscal sessions
export const getAllDistrict = () => axiosInstance.get(`${districtURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageDistrict = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${districtURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getDistrictById = (id) => axiosInstance.get(`${districtURL}/retrieve/${id}`);

//creating function
export const createDistrict = (body) => axiosInstance.post(`${districtURL}/create`, body);
//updating function
export const updateDistrict = (id, body) => axiosInstance.patch(`${districtURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${districtURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataDistrictName = (e, cancelToken) =>
  axiosInstance.get(`${districtURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
